import React from 'react';
import './PageHeader.css';

/**
 * Modern PageHeader Component
 * Page title with optional subtitle and actions
 */
const PageHeader = ({
    title,
    subtitle,
    actions,
    className = ''
}) => {
    return (
        <div className={`page-header ${className}`}>
            <div>
                <h1 className="page-header__title">{title}</h1>
                {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
            </div>

            {actions && (
                <div className="page-header__actions">
                    {actions}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
